import { render } from "./header.html?vue&type=template&id=1400ac76&scoped=true&ts=true"
import script from "./header.ts?vue&type=script&lang=ts"
export * from "./header.ts?vue&type=script&lang=ts"

import "./header.scss?vue&type=style&index=0&id=1400ac76&lang=scss&scoped=true"

import exportComponent from "/Users/fahadnaeem/Documents/MYLE Codes/myle-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1400ac76"]])

export default __exports__